import { createSlice } from '@reduxjs/toolkit';

interface SearchUiState {
  isSearchModalOpen: boolean;
}

const initialState: SearchUiState = {
  isSearchModalOpen: false,
};

const searchUiSlice = createSlice({
  name: 'searchUi',
  initialState,
  reducers: {
    openSearchModal(state) {
      state.isSearchModalOpen = true;
    },
    closeSearchModal(state) {
      state.isSearchModalOpen = false;
    },
  },
});

export const { openSearchModal, closeSearchModal } = searchUiSlice.actions;
export const searchUiReducer = searchUiSlice.reducer;
